import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'varianceArrow',
  standalone: false,
})
export class VarianceArrowPipe implements PipeTransform {
  transform(value: number, icon: string): string {
    if (Number.isNaN(value)) {
      return `<div>${value}</div>`;
    }
    return `
      <div class="text-${value < 0 ? 'danger' : 'success'}">
          ${new DecimalPipe('en-US').transform(value, '1.0-0')}
          <small>${icon}</small>
      </div>`;
  }
}
